<template>
  <div class="wrap">
    <div v-if="showSpinner" class="spinner-container">
      <spinner-el class="spinner" />
    </div>
    <template v-else>
      <select @change="onSelectPlan" v-model="selectedPlanType" class="select" size="20">
        <option value="free">Free</option>
        <option value="silver">Silver</option>
        <option value="gold">Gold</option>
      </select>
      <div class="select-wrap">
        <template v-if="selectedPlanType">
          <button-el class="select-wrap__btn" @click="setCreatingState">Create New</button-el>
          <select @change="onSelectTariff" v-model="selectedTariff" class="select select-wrap__select" size="20">
            <option v-for="tariff in tariffs[selectedPlanType]" :key="tariff.id" :value="tariff">
              [{{tariff.active ? '✓' : '&nbsp;&nbsp;'}}]{{tariff.nickname}}
            </option>
          </select>
        </template>
      </div>
      <div class="quotas">
        <template v-if="selectedTariffForEdit">
          <template v-if="!creatingState">
            <div class="quotas__row btns">
              <button-el v-if="!openedTariffIsNotAvailableForEdit" @click="saveTariff">Save</button-el>
              <button-el v-if="!selectedTariffForEdit.active" @click="activateTariff" red>Activate</button-el>
              <button-el v-if="openedTariffIsAvailableForDelete" @click="deleteTariff">Delete</button-el>
            </div>
            <div class="quotas__row">created: <b>{{selectedTariffForEdit.createdAt | format(dateTimeFormat)}}</b></div>
            <div class="quotas__row">users count: <b>{{selectedTariffForEdit.usersCount}}</b></div>
          </template>
          <input-el maxlength="16" :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="text" label="Name" v-model="selectedTariffForEdit.nickname" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="text" label="Description" v-model="selectedTariffForEdit.description" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Alerts Count" v-model.number="selectedTariffForEdit.alertsCount" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Cost" v-model.number="selectedTariffForEdit.cost" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Limit Email" v-model.number="selectedTariffForEdit.limitEmail" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Limit Push" v-model.number="selectedTariffForEdit.limitPush" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Limit SMS" v-model.number="selectedTariffForEdit.limitSMS" />
          <input-el :disabled="openedTariffIsNotAvailableForEdit" class="quotas__row" type="number" label="Limit Webhook" v-model.number="selectedTariffForEdit.limitWebhook" />
          <button-el class="create-btn" v-if="creatingState" @click="createTariff">Create</button-el>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { format } from 'date-fns';
import { dateTimeFormat } from 'src/utils/config';

export default {
  filters: {
    format,
  },
  data: () => ({
    creatingState: false,
    selectedPlanType: null,
    selectedTariff: null,
    selectedTariffForEdit: null,
    showSpinner: true,
    tariffs: [],
  }),
  methods: {
    createTariff() {
      this.showSpinner = true;
      const newTariff = {
        ...this.tariffForSending,
        planType: this.selectedPlanType,
      };
      this.$apiService.createTariff(newTariff).then(() => {
        alert('tariff was created'); // eslint-disable-line no-alert
        this.updateTariffs();
      });
    },
    setCreatingState() {
      this.selectedTariff = null;
      this.selectedTariffForEdit = {
        nickname: null,
        description: null,
        alertsCount: null,
        cost: null,
        limitEmail: null,
        limitPush: null,
        limitSMS: null,
        limitWebhook: null,
      };
      this.creatingState = true;
    },
    saveTariff() {
      if (confirm('Are you sure?')) { // eslint-disable-line no-alert
        this.$apiService.updateTariff(this.selectedTariff.id, this.tariffForSending).then(() => {
          alert('tariff was saved'); // eslint-disable-line no-alert
          this.updateTariffs();
        });
      }
    },
    deleteTariff() {
      if (confirm('Are you sure?')) { // eslint-disable-line no-alert
        this.$apiService.deleteTariff(this.selectedTariff.id).then(() => {
          alert('tariff was deleted'); // eslint-disable-line no-alert
          this.updateTariffs();
        });
      }
    },
    activateTariff() {
      if (confirm('Are you sure?')) { // eslint-disable-line no-alert
        this.$apiService.activateTariff(this.selectedTariff.id).then(() => {
          alert('tariff was activated'); // eslint-disable-line no-alert
          this.updateTariffs();
        });
      }
    },
    updateTariffs() {
      this.showSpinner = true;
      this.$apiService.getAdminTariffsList().then((tariffs) => {
        this.tariffs = tariffs;
        this.showSpinner = false;
      });
    },
    onSelectTariff() {
      this.selectedTariffForEdit = cloneDeep(this.selectedTariff);
      this.creatingState = false;
    },
    onSelectPlan() {
      this.selectedTariff = null;
      this.selectedTariffForEdit = null;
    },
  },
  computed: {
    dateTimeFormat: () => dateTimeFormat,
    tariffForSending() {
      if (!this.selectedTariffForEdit) {
        return null;
      }
      return {
        name: this.selectedTariffForEdit.nickname,
        description: this.selectedTariffForEdit.description,
        alertsCount: this.selectedTariffForEdit.alertsCount,
        limitSMS: this.selectedTariffForEdit.limitSMS,
        limitEmail: this.selectedTariffForEdit.limitEmail,
        limitPush: this.selectedTariffForEdit.limitPush,
        limitWebhook: this.selectedTariffForEdit.limitWebhook,
        cost: this.selectedTariffForEdit.cost,
      };
    },
    openedTariffIsNotAvailableForEdit() {
      return this.selectedTariffForEdit.usersCount > 0;
    },
    openedTariffIsAvailableForDelete() {
      return !this.openedTariffIsNotAvailableForEdit && !this.selectedTariff.active;
    },
  },
  created() {
    this.updateTariffs();
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.wrap {
  display: flex;
  justify-content: center;
  align-items: bottom;
}
$border: 1px solid $grey-color6;
.select {
  width: 200px;
  text-align: center;
  outline: none;
  border: none;
  border-right: $border;
}
.spinner-container {
  display: flex;
  justify-content: center;
}
.quotas {
  height: 670px;
  overflow-y: scroll;
  background: $white-color2;
  width: 516px;
  padding: 38px 30px;
  &__row {
    margin-top: 20px;
  }
  position: relative;
}
.btns {
  position: absolute;
  top: -15px;
  width: 460px;
  background: $white-color2;
}
.select-wrap {
  position: relative;
  width: 200px;
  background-color: $white-color2;
  border-right: $border;
  &__select {
    height: 100%;
    width: 100%;
    padding-top: 60px;
    border-right: none;
  }
  &__btn {
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.create-btn {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/admin/TariffsManage.vue